module.exports = __webpack_public_path__ + "static/media/cb-desktop.33fa6342.png";